import { AboutService } from './about.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { Page } from '@data/models/page.model';
import { SEOService } from '@data/services/meta-data.service';
import { Image } from '@data/models/image.model';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
})
export class AboutComponent implements OnInit {
  content$: Observable<Page>;
  images: Image[];

  constructor(
    private route: ActivatedRoute,
    private aboutService: AboutService,
    private seoService: SEOService
  ) {}

  ngOnInit(): void {
    this.content$ = this.aboutService.getContent().pipe(
      tap((page) => {
        this.setSeoData(page);
      })
    );
  }

  setSeoData(page: Page): void {
    this.seoService.setMetaData(page.metaTitle, page.metaDescription);
  }
}
